// @flow
import { connect } from 'react-redux'
import VkDisclaimers from './VkDisclaimers'
import type { Store } from '../../redux/ducks'
import type { State as AudienceState } from '../../redux/ducks/audienceEdit/reducers'
import { patch } from '../AudienceEditContainer'

function mapStateToProps(state: Store) {
  const audienceState = state.audienceEdit

  return {
    disclaimerFinance: audienceState.disclaimerFinance,
    financeName: audienceState.financeName,
    financeNameErrors: audienceState.financeNameErrors,
    financeLicenseNumber: audienceState.financeLicenseNumber,
    financeLicenseNumberErrors: audienceState.financeLicenseNumberErrors,
    disclaimerMedical: audienceState.disclaimerMedical,
    disclaimerSpecialist: audienceState.disclaimerSpecialist,
    disclaimerSupplements: audienceState.disclaimerSupplements
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onChange: (diff: $Shape<AudienceState>) => patch(dispatch, diff)
  }
}

const VkDisclaimersContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(VkDisclaimers)

export default VkDisclaimersContainer
